export default __webpack_public_path__ + "static/media/guns_light.b2eba405.png";